<script>
  import { onMount } from "svelte";
  import {External} from "../external";

  export let selectedFont = "";
  export let useOnlyEmailSafeFonts = false;

  let fonts = [];

  onMount(() => {
    if (useOnlyEmailSafeFonts) {
      fonts = External.Tools.EMAIL_EDITOR_FONTS;
    } else {
      let stripDuplicates = (fonts) => {
        for (let i = 0; i < fonts.length; i++) {
          if (fonts.indexOf(fonts[i]) !== i) {
            fonts.splice(i, 1);
          }
        }
        return fonts;
      };

      fonts = stripDuplicates(External.GlobalStyling.getAvailableFontNames());
    }
  });
</script>

<select name="font-picker" bind:value={selectedFont}>
  {#if fonts.length > 0}
    {#each fonts as font (font)}
      <option value={font}>{font}</option>
    {/each}
  {/if}
</select>
